import { create } from "zustand";
import axios from "axios";
import { persist, devtools } from "zustand/middleware";

const useUserStore = create()(
  devtools((set) => ({
    userCreated: [],

    getRegUser: async () => {
      const response = await axios.get(process.env.REACT_APP_SHOW_USER);
      set({ userCreated: response.data });
    },
    registerUser: async (payload) => {
      const response = await axios.post(
        process.env.REACT_APP_REGISTER_USER,
        payload
      );
      set({ userCreated: response.data });
    },
  }))
);

const useTemplateStore = create()(
  devtools((set) => ({
    templateCreated: [],

    getTemplates: async () => {
      const response = await axios.get(process.env.REACT_APP_SHOW_TEMPLATE);
      set({ templateCreated: response.data });
    },
    addTemplate: async (payload) => {
      const response = await axios.post(
        process.env.REACT_APP_ADD_TEMPLATE,
        payload
      );
      set({ templateCreated: response.data });
    },
  }))
);

const useLoginStore = create()(
  // persist(
  (set) => ({
    isLogin: null,
    access_level: null,
    firstname: null,
    lastname: null,
    department: null,
    username: null,

    setUser: (userData) => {
      set({
        isLogin: userData,
        firstname: userData.firstname,
        lastname: userData.lastname,
        access_level: userData.access_level,
        department: userData.department,
        username: userData.username,
      });
    },

    userLogout: () => {
      set({
        isLogin: null,
        firstname: null,
        lastname: null,
        username: null,
        access_level: null,
      });
    },
  })
  // ,
  // {
  //   name: "user",
  // }
  // )
);

const useMessageStore = create()(
  devtools((set) => ({
    messageData: [],
    textInput: "",
    numberInput: "",

    getInbox: async () => {
      const response = await axios.get(process.env.REACT_APP_SHOW_MESSAGES);
      set({ messageData: response.data });
    },

    setTextInput: (str) => {
      set({ textInput: str });
    },

    setNumInput: (str) => {
      set({ numberInput: str });
    },
  }))
);

export { useLoginStore, useMessageStore, useUserStore, useTemplateStore };
